import React from 'react'
import { Link, useLocation } from 'react-router-dom';

export default function ConsPostBreadCrumbs() {
    const location = useLocation();
    const vPathName = location.pathname;
    return (
        <div className="container-fluid p-0 mt-0 mb-3 breadcrumb">
            {vPathName === '/ConsolidationPosting' ? (
                <div>
                    <span className="breadcrumb-arrow-inactive ">Consolidation Post Summary</span>
                </div>
            ) : (
                    <></>

                )}
        </div>
    );
}

